var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90516 0.219646C6.61266 -0.0732282 6.13716 -0.0732282 5.84466 0.219646L2.62491 3.43902L1.28016 2.09464C0.987658 1.80177 0.512158 1.80177 0.219658 2.09464C-0.0732171 2.38752 -0.0732171 2.86227 0.219658 3.15514L2.09466 5.03014C2.24091 5.17676 2.43291 5.24989 2.62491 5.24989C2.81691 5.24989 3.00891 5.17676 3.15516 5.03014L6.90516 1.28014C7.19804 0.98727 7.19804 0.512521 6.90516 0.219646Z",
    fill: "#F8F8F8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/vi.6d3ad08947ed955f499a8224e8584608.svg";
export { ForwardRef as ReactComponent };